import { RouteConfig } from 'vue-router';
import Applications from '@/apps/applications/Applications.vue';
import ShowApplication from '@/apps/applications/ShowApplication.vue';
import { requireSeeker } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration } from '@/router/guards/completionGuards';
import applicationsBadgeGuard from '@/router/guards/applicationsBadgeGuard';
import combineGuards from '@/router/guards/helpers';

const applicationsRoutes: RouteConfig[] = [
  {
    path: '/jobs/:job_uuid/applications',
    name: 'applications',
    component: Applications,
    beforeEnter: combineGuards([requireSeeker, checkPremiumParentRegistration, applicationsBadgeGuard]),
    children: [
      {
        path: ':application_uuid',
        name: 'show-application',
        component: ShowApplication,
      },
    ],
  },
  // Legacy redirect route for old ID-based URLs
  {
    path: '/jobs/:id(\\d+)/applications',
    name: 'redirect-to-uuid',
    redirect: (to) => {
      const { id } = to.params;
      window.location.href = `/jobs/action_with_id?job_action=applications&id=${id}`;
      return '/'; // Return a valid route, though window.location.href will handle the redirect
    },
  },
];

export default applicationsRoutes;
